import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    daily: {
        loading: true,
        data: {},
        error: null,
    },
    currentMonth: {
        loading: true,
        data: {},
        error: null,
    },
    previousMonth: {
        loading: true,
        data: {},
        error: null,
    },

}
export const domainCallCountSlice = createSlice({
    name: 'domainCallCount',
    initialState,
    reducers: {

        setDomainCallCountLoading: (state, action) => {
            const { countType } = action.payload;
            state[countType].loading = true;
        },
        setDomainCallCount: (state, action) => {
            const { countType, data } = action.payload;
            state[countType].loading = false;
            state[countType].data = data;
        },
        resetDomainCallCount: () => initialState,

    },

});

export const {
    setDomainCallCountLoading,
    setDomainCallCount,
    resetDomainCallCount
} = domainCallCountSlice.actions;

export const selectDailyDomainCallCount = (state) => state.domainCallCount.daily;
export const selectCurrentMonthDomainCallCount = (state) => state.domainCallCount.currentMonth;
export const selectPreviousMonthDomainCallCount = (state) => state.domainCallCount.previousMonth;
export default domainCallCountSlice.reducer;